import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {articles} from "../../modules/articles";

declare var ko: any;

export class filterArticle_template extends vnTemplate {
    static SINGLE_SELECTION_MODE: string = 'single';
    static MULTIPLE_SELECTION_MODE: string = 'multiple';

    protected suggestionsDocumentClickHandler: ((event: MouseEvent) => void) | null = null;

    protected idArticleContainer: string = 'selected-articles';
    protected articleCaption: string = 'Selected Articles:';
    protected wrapperClass: string = " ";

    protected getTemplateHtml(): string {

        return `
                <div class="w-spec-search icon i-auto-complete i-article-a" data-bind="css: { 'is-suggestions-open': isShowArticleSuggestions }">
                    <input data-bind="textInput: article, disable: disableField(), event: { keyup: onChangeInput}, valueUpdate : 'afterkeydown', attr:{id:idArticle, placeholder: placeholder, readonly : $parent.isPublishingControl}" class="input-text">
                    <!-- ko if: isLoadingAnimationEnable() && optionsLoading() -->
                    <span class="form-loading" ></span>
                    <!-- /ko -->
                    <ul class="form-auto-list" data-bind="foreach: articles, visible: isShowArticleSuggestions" id="articles">
                        <!-- ko ifnot: $parent.showDetails() || $parent.showBrand() -->
                            <li class="form-auto-item" data-bind="attr:{id:id}, text: $data.title, click: $parent.onBlurArticle" ></li>
                        <!-- /ko -->

                        <!-- ko if: $parent.showBrand() -->
                            <li class="form-auto-item" data-bind="attr:{id:id}, click: $parent.onBlurArticle" >
                                <span class="title" data-bind="text: $data.title"></span>
                                <span class="date" data-bind="attr:{id:id}, text: $data.brandName, click: $parent.onBlurArticle" ></span>
                            </li>
                        <!-- /ko -->

                        <!-- ko if: $parent.showDetails() -->
                            <li class="form-auto-item" data-bind="attr:{id:id}, click: $parent.onBlurArticle">
                                <span class="title" data-bind="text: $data.title"></span>
                                <span class="date">ID:
                                    <span data-bind="text: $data.id ?? ''"></span>
                                </span>
                                <span class="date">Last Published:
                                    <span data-bind="text: $data.dateMostRecentPublishedStatus ? $data.dateMostRecentPublishedStatus : 'Never Published'"></span>
                                </span>
                            </li>
                        <!-- /ko -->
                    </ul>
                    <button data-bind="visible: !disableField(), attr: {id: 'user-input-close_' + elementIdentifier()}, event: { click: onClearInput }, css: { 'is-showing': article()}" class="close-btn icon i-x-after" type="button"><span class="hidden-text">close</span></button>
                </div>
                `;
    }

    protected getTemplateName(): string {
        return "filterArticle-template";
    }

    protected getMainElementClasses(): Array<string> {
        return [];
    }

    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let self = this;
        return {
            selectionMode: ko.observable(filterArticle_template.SINGLE_SELECTION_MODE),
            hasSelectedElementWrapper: ko.observable(false),
            selectedElementWrapperClass: ko.observable(null),
            customElementClass: ko.observable(null),
            articles: ko.observableArray([]),
            idArticle: ko.observable(null),
            article: ko.observable(""),
            articleObj: ko.observable(null),
            articleObjs: ko.observableArray([]),
            orderBy: "dateCreation",
            orderByDirection: "DESC",
            placeholder: ko.observable("Article"),
            isShowArticleSuggestions: ko.observable(false),
            elementIdentifier: ko.observable(this.idElement),
            showDetails: ko.observable(false),
            showSelectedArticlesDetails: ko.observable(false),
            showBrand: ko.observable(false),
            isLoadingAnimationEnable: ko.observable(false),
            optionsLoading: ko.observable(false),
            disableField: ko.observable(false),
            onChangeInput: function (data, event) {
                self.onChangeInput(data, event);
            },
            onClearInput: function (data, event) {
                self.onClearInput(event);
            },
            onChangeFilterAction: function (data, event) {
                self.onChangeFilterAction(data)
            },
            onBlurArticle: function (data, event) {
                self.onBlurArticle(data, event);
            }
        };
    }

    protected onChangeFilterAction(data) {
        this.caller.filterSimpleOnChange(this.idElement);
    }

    protected setShowArticleSuggestions(show: boolean): void {
        this.getTemplateViewModel().isShowArticleSuggestions(show);

        if (show) {
            this.bindSuggestionsDocumentClick();
            return;
        }

        this.unbindSuggestionsDocumentClick();
    }

    protected dismissArticleSuggestions(): void {
        this.getTemplateViewModel().optionsLoading(false);
        this.setShowArticleSuggestions(false);
    }

    protected bindSuggestionsDocumentClick(): void {
        this.unbindSuggestionsDocumentClick();
        this.suggestionsDocumentClickHandler = (event: MouseEvent) => {
            const target = event.target as Element | null;
            const container = document.getElementById(this.idElement);

            if (!target || !container || !container.contains(target)) {
                this.dismissArticleSuggestions();
            }
        };

        window.setTimeout(() => {
            if (this.getTemplateViewModel().isShowArticleSuggestions() && this.suggestionsDocumentClickHandler) {
                document.addEventListener("click", this.suggestionsDocumentClickHandler);
            }
        }, 0);
    }

    protected unbindSuggestionsDocumentClick(): void {
        if (this.suggestionsDocumentClickHandler) {
            document.removeEventListener("click", this.suggestionsDocumentClickHandler);
            this.suggestionsDocumentClickHandler = null;
        }
    }

    protected onChangeInput(data, event) {
        let input = event.target;
        let inputWrapper = input.parentNode;
        //put this back if there's a problem with 'css: { 'is-showing': article() != null }' in KO
/*        let closeBtn = inputWrapper.querySelector('#user-input-close_'+ this.viewModel[this.idElement].elementIdentifier());

        if (!closeBtn.classList.contains('is-showing')) {
            closeBtn.classList.add('is-showing');
        }*/
        this.getTemplateViewModel().optionsLoading(true);
        this.onChangeArticleDataListArticle(event, this.viewModel[this.idElement].idArticle);
    }

    protected onChangeArticleDataListArticle(event, idArticle) {
        let input = event.target,
            inputVal = input.value,
            optionsList = input.getAttribute('list'),
            options: any = document.getElementById("articles").childNodes;
        if (inputVal.length >= 3) {

            this.caller.getArticlesSuggestion(inputVal, this.idElement);
            this.setShowArticleSuggestions(true);
        }else {

            this.setShowArticleSuggestions(false);
        }

        if (inputVal.length == 0) {

            let closeBtn = document.querySelector('#user-input-close_'+ this.viewModel[this.idElement].elementIdentifier());
            //put this back if there's a problem with 'css: { 'is-showing': article() != null }' in KO
/*            if (closeBtn.classList.contains('is-showing')) {

                closeBtn.classList.remove('is-showing');
            }*/
            this.viewModel[this.idElement].idArticle(null);
            this.viewModel[this.idElement].article("");
            this.viewModel[this.idElement].articleObj("");

            this.caller.filterSimpleOnChange(this.idElement);
        }

        for (let op of options) {
            if (op.value === inputVal) {
                idArticle(op.id);
                input.blur();
                this.caller.filterSimpleOnChange(this.idElement);
                break;
            }
        }
    }

    protected onClearInput(event) {

        let button = event.target;
        this.dismissArticleSuggestions();
        if (button.classList.contains('is-showing')) {

            this.viewModel[this.idElement].idArticle(null);
            this.viewModel[this.idElement].article("");
            this.viewModel[this.idElement].articleObj("");
            //this one is necessary
            button.classList.remove('is-showing');

            this.caller.filterSimpleOnChange(this.idElement);
        }
    }

    protected onBlurArticle(data, event) {
        this.getTemplateViewModel().article(data.title)
        this.getTemplateViewModel().articleObj(data)
        this.getTemplateViewModel().idArticle(data.id);
        this.dismissArticleSuggestions();
        this.handleSelectionModeSpecific(data);


        let closeBtn = document.querySelector('#user-input-close_'+ this.viewModel[this.idElement].elementIdentifier());
            //put this back if there's a problem with 'css: { 'is-showing': article() != null }' in KO
/*        if (!closeBtn.classList.contains('is-showing')) {
            closeBtn.classList.add('is-showing');
        }*/

        this.caller.filterSimpleOnChange(this.idElement);
    }

    private handleSelectionModeSpecific(data): void {

        if (this.getSelectionMode() == filterArticle_template.MULTIPLE_SELECTION_MODE) {
            if (this.getArticleObjs().length == 0) {
                this.addCaption();
                if(this.getHasSelectedElementWrapper()) {
                    this.createSelectedElementsWrapper();
                }
            }
            this.appendToSelection(data);
            this.clearInput();
        } else {
            this.replaceInSelection(data);
        }
    }

    public setShowDetails(boolean){

        this.getTemplateViewModel().showDetails(boolean)
    }

    public setShowBrand(boolean){

        this.getTemplateViewModel().showBrand(boolean);
    }

    public setIsLoadingAnimationEnable(boolean){

        this.getTemplateViewModel().isLoadingAnimationEnable(boolean)
    }

    public setOptions(articles){

        this.getTemplateViewModel().optionsLoading(false);
        this.getTemplateViewModel().articles(articles)
    }

    public setDisableField(disableField: boolean): void {
        this.getTemplateViewModel().disableField(disableField);
        this.syncSelectedArticlesRemoveButtons();
    }

    public getDisableField(): boolean {
        return this.getTemplateViewModel().disableField();
    }

    protected canRemoveSelectedArticle(): boolean {
        return !this.getDisableField();
    }

    protected syncSelectedArticlesRemoveButtons(): void {
        if (!this.getShowSelectedArticlesDetails() || !this.getArticleContainer()) {
            return;
        }

        const canRemove = this.canRemoveSelectedArticle();
        this.getArticleContainer().querySelectorAll(':scope > div[id]').forEach((item: HTMLElement) => {
            const buttonWrapper = item.querySelector('.w-btn');
            if (!canRemove && buttonWrapper) {
                buttonWrapper.remove();
            } else if (canRemove && !buttonWrapper) {
                item.appendChild(this.createSelectedArticleRemoveButton());
            }
        });
    }

    protected createSelectedArticleRemoveButton(): HTMLDivElement {
        const buttonWrapper = document.createElement('div');
        buttonWrapper.setAttribute('class', 'w-btn');

        const deleteBtn = document.createElement('button');
        deleteBtn.setAttribute('class', 'btn border only-icon icon border highlight i-delete');
        deleteBtn.setAttribute('type', 'button');
        deleteBtn.addEventListener('click', this.onSelectedElementClick.bind(this), false);
        buttonWrapper.appendChild(deleteBtn);

        return buttonWrapper;
    }

    public setSelectedArticle(article?: { id: number, title: string }): void {
        if(article){
            this.getTemplateViewModel().article(article.title)
            this.getTemplateViewModel().articleObj(article)
            this.getTemplateViewModel().idArticle(article.id);
        } else {
            this.getTemplateViewModel().article("")
            this.getTemplateViewModel().articleObj("")
            this.getTemplateViewModel().idArticle(null);
        }
    }

    public setSelectionMode(selectionMode): void {
        this.getTemplateViewModel().selectionMode(selectionMode);
    }

    public getSelectionMode() {
        return this.getTemplateViewModel().selectionMode();
    }

    public getArticleObjs(): any {
        return this.getTemplateViewModel().articleObjs();
    }

    public getArticleObj(): any {
        return this.getTemplateViewModel().articleObj();
    }

    protected addCaption()
    {
        if (!this.getCaption()) {
            this.createCaption();
        }
    }

    protected getArticleContainer(): any {
        return document.querySelector(`#${this.idArticleContainer}`);
    }

    protected getSelectedElementContainer(): any {
        return this.getHasSelectedElementWrapper() ? document.querySelector(`#${this.idArticleContainer}-wrapper`) : this.getArticleContainer();
    }

    protected getCaption()
    {
        return document.querySelector(`#${this.idArticleContainer} label`);
    }

    protected createCaption()
    {
        let element = document.createElement('label');

        element.setAttribute('class', 'small');
        element.appendChild(document.createTextNode(this.articleCaption));

        this.getArticleContainer().appendChild(element);

        return element;
    }

    protected createSelectedElementsWrapper() {
        let element = document.createElement('div');
        element.setAttribute('id', `${this.idArticleContainer}-wrapper`);
        element.setAttribute('class', this.getSelectedElementWrapperClass());
        this.getArticleContainer().appendChild(element);

        return element;
    }

    private appendToSelection(article): void {
        let articles = this.getArticleObjs();
        let filtered = articles.filter((a) => a.id == article.id);
        if (filtered.length == 0) {

            articles.push(article);
            this.addHtmlArticle(article);
            this.setArticleObjs(articles);
        }
    }

    protected addHtmlArticle(article)
    {
        if (this.getSelectedElementContainer()) {
            let element = null;
            if(this.getShowSelectedArticlesDetails()) {
                element = this.createDetailedArticleHtmlElement(article);
            } else {
                element = this.createArticleHtmlElement(article);
            }
            this.getSelectedElementContainer().appendChild(element);
        }
    }

    public setArticles(articles): void {
        this.resetArticleContainer();
        if(Array.isArray(articles)) {
            articles.forEach((article) => {
                this.handleSelectionModeSpecific(article);
            });
        } else {
            this.handleSelectionModeSpecific(articles);
        }
    }

    public setArticleObjs(articleObjs): void {
        if(this.getSelectionMode() == filterArticle_template.MULTIPLE_SELECTION_MODE && Array.isArray(articleObjs)) {
            this.getTemplateViewModel().articleObjs(articleObjs);
        } else {
            let articleObj = articleObjs;
            if(Array.isArray(articleObj)) {
                articleObj = articleObjs[0];
            }
            this.getTemplateViewModel().articleObj(articleObj);
        }
    }

    protected createArticleHtmlElement(article)
    {
        let element = document.createElement('button');

        element.setAttribute('id', article.id);
        element.appendChild(document.createTextNode(article.title));
        element.setAttribute('class', `btn-f-s icon i-x-after ${this.getCustomElementClass()}`);
        element.setAttribute('type', 'button');

        element.addEventListener('click', this.onSelectedElementClick.bind(this), false);

        return element;
    }

    protected createDetailedArticleHtmlElement(article) {

        let element = document.createElement('div');

        element.setAttribute('id', article.id);
        element.setAttribute('class', `${this.getCustomElementClass()}`);

        let titleWrapper = document.createElement('div');
        titleWrapper.setAttribute('class', `w-title`);
        element.appendChild(titleWrapper);

        let infoWrapper = document.createElement('div');
        titleWrapper.appendChild(infoWrapper);

        let idElement = document.createElement('span');
        idElement.setAttribute('class', 'pinned-info');
        idElement.innerText = `ID: ${article.id}`;
        infoWrapper.appendChild(idElement);

        let dateText = "Last Published: Never Published";
        if(article.dateMostRecentPublishedStatus) {
            let date = new Date(article.dateMostRecentPublishedStatus);
            dateText = `Last Published: ${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
        }

        let dateElement = document.createElement('p');
        dateElement.setAttribute('class', 'pinned-info');
        dateElement.innerText = dateText;
        infoWrapper.appendChild(dateElement);

        let titleElement = document.createElement('h5');
        titleElement.setAttribute('class', 'pinned-title');
        titleElement.innerHTML = article.title;
        titleWrapper.appendChild(titleElement);

        if (this.canRemoveSelectedArticle()) {
            element.appendChild(this.createSelectedArticleRemoveButton());
        }

        return element;
    }

    protected onSelectedElementClick(event) {
        let element = event.target;

        if(this.getShowSelectedArticlesDetails()) {
            while (!(element instanceof HTMLDivElement) || !element.id) {
                element = element.parentElement;
            }
        }

        this.removeElementFromSelection(element.getAttribute('id'));
        this.getSelectedElementContainer().removeChild(element);

        if (this.getArticleObjs().length == 0) {
            this.resetArticleContainer();
        }

        this.caller.filterSimpleOnChange(this.idElement);
    }

    private removeElementFromSelection(idArticle): void {
        let articles = this.getArticleObjs().filter((a) => a.id != idArticle);
        if (this.getShowSelectedArticlesDetails()) {
            this.getTemplateViewModel().articleObjs(articles);
            return;
        }

        this.setArticleObjs(articles);
    }

    public resetArticleContainer(): void {
        if (this.getArticleContainer()) {
            this.getArticleContainer().innerHTML = '';
            this.getTemplateViewModel().articleObjs([]);
            this.setArticleObjs([]);
        }
    }

    public clearInput() {
        const articleFilterElement = document.querySelector(`#${this.idElement}`) as HTMLElement;
        if (articleFilterElement) {
            let button = articleFilterElement.querySelector(`#user-input-close_${this.idElement}`);
            if (button && button.classList.contains('is-showing')) {
                button.classList.remove('is-showing');
                this.viewModel[this.idElement].idArticle(null);
                this.viewModel[this.idElement].article("");
                this.viewModel[this.idElement].articles([]);
                this.viewModel[this.idElement].articleObj("");
                this.setShowArticleSuggestions(false);
            }
        }
    }

    private replaceInSelection(article): void {
        if (this.getShowSelectedArticlesDetails() && this.getArticleContainer()) {
            this.getArticleContainer().innerHTML = '';
            this.getTemplateViewModel().articleObjs([article]);
            this.addHtmlArticle(article);
            this.clearInput();
            return;
        }

        this.setArticleObjs([]);
        this.setArticleObjs([article]);
    }

    public setShowSelectedArticlesDetails(showSelectedArticlesDetails: boolean): void {
        this.getTemplateViewModel().showSelectedArticlesDetails(showSelectedArticlesDetails);
    }

    protected getShowSelectedArticlesDetails(): boolean {
        return this.getTemplateViewModel().showSelectedArticlesDetails();
    }

    public setHasSelectedElementWrapper(hasSelectedElementWrapper: boolean): void {
        this.getTemplateViewModel().hasSelectedElementWrapper(hasSelectedElementWrapper);
    }

    protected getHasSelectedElementWrapper(): boolean {
        return this.getTemplateViewModel().hasSelectedElementWrapper();
    }

    public setSelectedElementWrapperClass(selectedElementWrapperClass: string): void {
        this.getTemplateViewModel().selectedElementWrapperClass(selectedElementWrapperClass);
    }

    protected getSelectedElementWrapperClass(): string {
        return this.getTemplateViewModel().selectedElementWrapperClass();
    }

    public setCustomElementClass(customElementClass: string): void {
        this.getTemplateViewModel().customElementClass(customElementClass);
    }

    protected getCustomElementClass(): string {
        return this.getTemplateViewModel().customElementClass();
    }

    public setTagContainerId(tagContainerId: string): void {
        this.idArticleContainer = tagContainerId;
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/filterArticle_template.ts